module.exports = __webpack_public_path__ + "img/shogi_2021_pack_3_0005.04cabd77.png";